var exports = {
  "k": "x4ddf2309--e6f3ff--container",
  "X": "x4ddf2309--e6f3ff--scroller",
};

module.exports = exports;
